<template>
  <div class="login-body bg-F3F4F9">
    <div class="auth-navigationbar bg-282B80 cursor">
      <!-- <img src="../../../../assets/icon-lib-logo-bg.png" class="cursor" @click="toHome"> -->
      <!-- <img src="@/assets/image@2x.png" class="cursor" @click="toHome"> -->
      <img :src="clients.logoMain" @click="toHome" alt="">
    </div>
    <div class="auth-body flex-center">
      <div class="auth-body-view bg-white" :style="{paddingBottom: canSkip?'30px':'50px'}">
        <div class="auth-body-view-menu flex-center">
          <div class="cursor" @click="changeLoginType(0)">
            <p class="font-size-20 font-color-264480" :class="[menuSelindex==0?'font-bold':'',menuSelindex==1?'opacity':'']">读者账号认证</p>
          </div>
          <div class="auth-body-view-menu-line" />
          <div class="cursor" @click="changeLoginType(1)">
            <p class="font-size-20 font-color-264480" :class="[menuSelindex==1?'font-bold':'',menuSelindex==0?'opacity':'']">校友认证</p>
          </div>
        </div>

        <!-- 读者证号认证 -->
        <div v-if="menuSelindex==0">
          <!-- 手机号短信验证码表单 -->
          <div class="auth-body-view-menu-form">
            <div class="auth-body-view-menu-form-item" :class="accountError?'auth-body-view-menu-form-item-inputerror':''">
              <div class="flex flex-row-align-center auth-body-view-menu-form-item-option">
                <img src="../../../../assets/icon-lib-auth-account.png" alt="">
                <el-input v-model="readerAccount" placeholder="请输入读者账号/学号" size="normal" @blur="readerBlur" />
              </div>
            </div>

            <!-- 输入手机号规则校验错误提示 -->
            <div v-if="accountError" class="auth-body-view-menu-form-ruleerror">
              <div class="flex-row-align-center ">
                <p class="font-size-12 font-color-CD2E2E">请输入正确的账号/学号</p>
              </div>
            </div>

            <div class="auth-body-view-menu-form-item" :class="passwordError?'auth-body-view-menu-form-item-inputerror':''">
              <div class="flex flex-row-align-center auth-body-view-menu-form-item-option">
                <img src="../../../../assets/icon-lib-auth-password.png" alt="">
                <el-input v-model="readerPassword" placeholder="请输入密码" size="normal" type="password" @blur="passwordBlur" />
              </div>
            </div>
          </div>

          <!-- 输入密码规则校验错误提示 -->
          <div v-if="passwordError" class="auth-body-view-menu-form-ruleerror">
            <div class="flex-row-align-center ">
              <p class="font-size-12 font-color-CD2E2E">请输入密码</p>
            </div>
          </div>

        </div>

        <!-- 校友认证 -->
        <div v-else>
          <!-- 手机号短信验证码表单 -->
          <div class="auth-body-view-menu-form">
            <div class="auth-body-view-menu-form-item" :class="userNameError?'auth-body-view-menu-form-item-inputerror':''">
              <div class="flex flex-row-align-center auth-body-view-menu-form-item-option">
                <img src="../../../../assets/icon-lib-auth-user.png" alt="">
                <el-input v-model="realName" placeholder="请输入真实姓名" size="normal" @blur="nameBlur" />
                <!-- <input :value="realName" class="flex-1 font-size-12 font-color-264480" type="text" placeholder="请输入真实姓名"> -->
              </div>
            </div>

            <!-- 输入手机号规则校验错误提示 -->
            <div v-if="userNameError" class="auth-body-view-menu-form-ruleerror">
              <div class="flex-row-align-center ">
                <p class="font-size-12 font-color-CD2E2E">请输入真实姓名</p>
              </div>
            </div>

            <div class="auth-body-view-menu-form-item" :class="userIDNumberError?'auth-body-view-menu-form-item-inputerror':''">
              <div class="flex flex-row-align-center auth-body-view-menu-form-item-option">
                <img src="../../../../assets/icon-lib-auth-account.png" alt="">
                <el-input v-model="personId" placeholder="请输入身份证号码" size="normal" @blur="userIDBlur" />
              </div>
            </div>
          </div>

          <!-- 输入密码规则校验错误提示 -->
          <div v-if="userIDNumberError" class="auth-body-view-menu-form-ruleerror">
            <div class="flex-row-align-center ">
              <p class="font-size-12 font-color-CD2E2E">请输入身份证号码</p>
            </div>
          </div>

          <div class="auth-body-view-menu-form-item" :class="cominScollDateError?'auth-body-view-menu-form-item-inputerror':''">
            <div class="flex flex-row-align-center auth-body-view-menu-form-item-option position-relative">
              <img src="../../../../assets/icon-lib-auth-account.png" alt="">
              <el-date-picker v-model="inTime" value-format="yyyy" type="year" size="normal" data-id="year" :clearable="false" placeholder="请选择入学年份" @blur="dateBlur" />
            </div>
          </div>
        </div>

        <!-- 输入密码规则校验错误提示 -->
        <div v-if="cominScollDateError" class="auth-body-view-menu-form-ruleerror">
          <div class="flex-row-align-center ">
            <p class="font-size-12 font-color-CD2E2E">请选择入学年份</p>
          </div>
        </div>

        <!-- 登录按钮 -->
        <div class="auth-body-view-login">
          <div class="auth-body-view-login-btn bg-282B80 flex-center cursor" @click="toAuth">
            <p class="font-color-white font-size-14 font-bold">立即认证</p>
          </div>
        </div>

        <div v-if="canSkip" class="auth-body-view-skip" @click="skipAuth">
          <div class="flex-center cursor">
            <p class="font-size-12 font-color-7B84A1">跳过，稍后认证</p>
          </div>
        </div>
      </div>
    </div>
    <authfail ref="authfail" />
  </div>
</template>

<script>

import authfail from '@/components/authfail/index.vue'
import api from '../../../../api/auth.js'

import user from '../../../../models/user.js'

export default {
  name: 'Auth',
  components: {
    authfail
  },
  data() {
    return {
      menuSelindex: 0,
      accountError: false,
      passwordError: false,
      userNameError: false,
      userIDNumberError: false,
      cominScollDateError: false,

      canSkip: false,

      readerAccount: null,
      readerPassword: null,

      realName: null,
      personId: null,
      inTime: null,

      redirectUrl: '',
      clients: ''
    }
  },
  created() {
    this.redirectUrl = this.$route.query.r || '/'
    this.canSkip = this.$route.query.skip !== 'n'
    let that = this;
    this.$store.dispatch('navigation/setNavigatorIndex', 0)
    setTimeout(() => {
      that.clients = that.$store.getters.application  
    }, 1200);
  },
  methods: {
    changeLoginType(t) {
      this.menuSelindex = t
    },
    toAuth() {
      if (this.menuSelindex === 0) {
        if (!this.readerAccount || this.readerAccount === '') {
          this.accountError = true
          this.$message({
            showClose: false,
            message: '请输入正确的账号/学号',
            type: 'error'
          })
          return
        }
        if (!this.readerPassword || this.readerPassword === '') {
          this.$message({
            showClose: false,
            message: '请输入密码',
            type: 'error'
          })
          this.passwordError = true
          return
        }
        this.accountError = false
        this.passwordError = false
        const that = this
        const params = {
          readerAccount: that.readerAccount,
          readerPassword: that.readerPassword
        }

        api.readerAuth(params).then(r => {
          that.$router.push({ path: that.redirectUrl })
          user.updateUser()
        }).catch(error => {
          that.$refs.authfail.showauthfail(error.message)
        })
      } else {
        if (!this.realName || this.realName === '') {
          this.$message({
            showClose: false,
            message: '请输入真实姓名',
            type: 'error'
          })
          this.userNameError = true
          return
        }
        if (!this.personId || this.personId === '') {
          this.$message({
            showClose: false,
            message: '请输入身份证号',
            type: 'error'
          })
          this.userIDNumberError = true
          return
        }
        if (!this.inTime || this.inTime === '') {
          this.$message({
            showClose: false,
            message: '请选择入学年份',
            type: 'error'
          })
          this.cominScollDateError = true
          return
        }
        this.cominScollDateError = false
        this.userNameError = false
        this.userIDNumberError = false
        const params = {
          alumnusName: this.realName,
          alumnusNumber: this.personId,
          alumnusYear: this.inTime
        }
        const that = this
        api.schoolAuth(params).then(r => {
          that.$router.push({ path: that.redirectUrl })
          user.updateUser()
        }).catch(error => {
          that.$refs.authfail.showauthfail(error.message)
        })
      }
    },
    skipAuth() {
      const that = this
      this.$router.push({
        path: that.redirectUrl
      })
    },
    toHome() {
      this.$store.dispatch('navigation/setNavigatorIndex', 0)
      this.$router.push({
        path: '/'
      })
    },
    readerBlur() {
      if (!this.readerAccount || this.readerAccount === '') {
        this.accountError = true
      } else {
        this.accountError = false
      }
    },
    passwordBlur() {
      if (!this.readerPassword || this.readerPassword === '') {
        this.passwordError = true
      } else {
        this.passwordError = false
      }
    },
    nameBlur() {
      if (!this.realName || this.realName === '') {
        this.userNameError = true
      } else {
        this.userNameError = false
      }
    },
    userIDBlur() {
      if (!this.personId || this.personId === '') {
        this.userIDNumberError = true
      } else {
        this.userIDNumberError = false
      }
    },
    dateBlur() {
      if (!this.inTime || this.inTime === '') {
        this.cominScollDateError = true
      } else {
        this.cominScollDateError = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  font-size: 12px !important;
    color: #264480 !important;
    padding: 0 !important;
    border: none !important;
     background: initial;
}
::v-deep .el-input__suffix-inner {
  display: none;
}
::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100% !important;
}
::v-deep .el-input__prefix {
  left: 0;
  display: none;
}
::v-deep .el-input__icon {
  width: initial !important;
}

/deep/ .el-select-dropdown__item.selected {
  color: #264480 !important;
}

</style>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped>
.login-body {
  flex: 1;
}

  .auth-navigationbar {
    width: 100%;
    height: 70px;
  }

  .auth-navigationbar img{
    width: auto;
    height: 100%;
  }

  .auth-body {
    width: 1240px;
    height: 510px;
    margin: 0 auto;
    background-color: #F3F4F9;
  }

  .auth-body-view {
    width: 600px;
    padding: 30px 0;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.05);
  }

  .auth-body-view-menu {
    height: 54px;
    width: 100%;
  }

  .auth-body-view-menu-line {
    width: 1px;
    height: 20px;
    background-color: #F3F4F9;
    margin: 0 26px;
  }

  .opacity {
    opacity: 0.7;
  }

  .auth-body-view-menu-form {
    margin-top: 20px;
  }

  .auth-body-view-menu-form-item {
    height: 40px;
    padding: 0 130px;
    margin-bottom: 24px;
  }

  .auth-body-view-menu-form-item-inputerror {
    margin-bottom: 0;
  }

  .auth-body-view-menu-form-item input {
    border: none;
    width: 100%;
    height: 40px;
    background-color: rgba(0, 0, 0, 0);
  }

  .auth-body-view-menu-form-item input:focus {
    outline: none;
  }

  .auth-body-view-menu-form-item-option {
    border: 1px solid #DEE0E7;
    height: 40px;
    width: 100%;
    padding: 0 8px;
    background: #F9F9FC;
  }

  .auth-body-view-menu-form-ruleerror {
    height: 40px;
    width: 100%;
    padding: 0 130px;
    margin-bottom: 8px;
  }

  .auth-body-view-menu-form-ruleerror>div {
    height: 40px;
  }

  .auth-body-view-menu-form-item-inputerror .auth-body-view-menu-form-item-option  {
    border: 1px solid #CD2E2E;
    height: 40px;
    width: 100%;
    padding: 0 8px;
    background: #FFEFEF;
  }

  .auth-body-view-menu-form-item-option-codebtn {
    padding: 6px 10px;
  }

  .auth-body-view-login {
    padding: 22px 130px 0;
  }

  .auth-body-view-login-btn {
    height: 40px;
  }

  .auth-body-view-wechat {
    padding: 10px 130px 0;
  }

  .auth-body-view-wechat-btn {
    height: 40px;
  }

  .auth-body-view-login-btn {
    height: 40px;
  }

  .auth-body-view-protocal {
    padding: 26px 0 0;
  }

  .auth-body-view-protocal-text {
    background: #FFFAEF;
    height: 40px;
  }

  .auth-body-view-skip {
    height: 40px;
    margin-top: 8px;
    padding: 0 130px;
  }

  .auth-body-view-skip>div {
    height: 40px;
    width: 100%;
  }

  .auth-body-view-menu-form-item .sel-date {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
  }

</style>
